<template>
  <div class="page">
    <div
      class="bg-fx"
      aria-hidden="true"
    >
      <div class="stars" />
      <div class="orb orb-1" />
      <div class="orb orb-2" />
      <div class="orb orb-3" />
      <div class="orb orb-4" />
    </div>
    <div
      class="scanline"
      aria-hidden="true"
    />

    <header class="page-header">
      <img
        src="../assets/logo.png"
        class="logo"
        alt=""
        @click="gourl"
      >
      <div class="language">
        <swithLanguage />
      </div>
    </header>

    <main class="page-main">
      <div class="card cyber-card">
        <span
          class="card-corner tl"
          aria-hidden="true"
        />
        <span
          class="card-corner tr"
          aria-hidden="true"
        />
        <span
          class="card-corner bl"
          aria-hidden="true"
        />
        <span
          class="card-corner br"
          aria-hidden="true"
        />
        <div
          class="card-glow"
          aria-hidden="true"
        />

        <div class="card-inner">
          <div class="card-header">
            <h2 class="card-title neon-text">
              {{ $t("pay.payTotalTxt") }}
            </h2>
            <div
              class="platform-badge"
              v-html="platformtext"
            />
          </div>

          <div class="form-section">
            <el-input
              v-model="TikTokID"
              type="text"
              class="input"
              :placeholder="TikTokID"
              disabled
            >
              <template #prepend>
                {{ $t("pay.platformUser") }}
              </template>
            </el-input>
            <el-input
              v-model="money"
              type="number"
              class="input"
              :placeholder="$t('pay.CNYText')"
              @input="num"
            >
              <template #prepend>
                {{ $t("pay.CNY") }}
              </template>
            </el-input>
            <el-input
              v-model="surplus"
              type="text"
              class="input"
              disabled
            >
              <template #prepend>
                {{ $t("pay.gameBalance") }}
              </template>
            </el-input>
            <el-input
              v-model="number"
              type="number"
              class="input"
              disabled
              placeholder="请输入充值金额(人民币)"
            >
              <template #prepend>
                {{ $t("pay.gameText") }}
              </template>
            </el-input>

            <div class="pay-actions">
              <el-button
                class="pay-btn pay-wechat pay-recommended"
                type="primary"
                size="large"
                color="#636ff1"
                @click="go"
              >
                <span class="btn-icon wechat">W</span>
                {{ $t("pay.wechatPay") }}
                <span class="recommended-badge">{{ $t("pay.recommended") }}</span>
              </el-button>
              <el-button
                class="pay-btn pay-alipay pay-recommended"
                type="primary"
                size="large"
                color="#636ff1"
                @click="alipay"
              >
                <span class="btn-icon alipay">A</span>
                {{ $t("pay.alipayPay") }}
                <span class="recommended-badge">{{ $t("pay.recommended") }}</span>
              </el-button>
              <el-button
                class="pay-btn pay-paypal pay-notice"
                type="primary"
                size="large"
                color="#636ff1"
                @click="paypal"
              >
                <span class="btn-icon paypal">P</span>
                {{ $t("pay.paypalPay") }}
                <span class="notice-badge">{{ $t("pay.viewNote") }}</span>
              </el-button>
              <el-button
                class="pay-btn pay-customer"
                type="primary"
                size="large"
                color="#636ff1"
                @click="customer"
              >
                <span class="btn-icon customer">C</span>
                {{ $t("pay.customer") }}
              </el-button>
            </div>

            <el-button
              class="logout-btn"
              type="danger"
              size="large"
              @click="logout"
            >
              {{ $t("pay.switchCard") }}
            </el-button>
          </div>
        </div>
      </div>
    </main>

    <el-drawer
      v-model="drawer"
      :title="$t('pay.wechatPayText')"
      direction="rtl"
      class="qr-drawer"
      @close="closeDrawer"
    >
      <div class="qr-container">
        <div class="qr-frame">
          <vue-qrcode
            :scale="options.scale"
            :value="pay_image"
            :widh="options.width"
            type="image/jpeg"
            :color="options.color"
          />
        </div>
      </div>
    </el-drawer>

    <footer class="bottom payment-note">
      <strong class="payment-note-title">{{ $t("pay.paypalNoticeTitle") }}</strong>
      <p>{{ $t("pay.paypalNoticeBody") }}</p>
    </footer>

    <div class="contact-badges">
      <div class="badge-item discord-badge">
        <img
          src="../assets/discord.svg"
          class="badge-icon"
          alt="Discord"
        >
        <span class="badge-text">xingyuhuyou</span>
      </div>
      <div class="badge-item wechat-badge">
        <img
          src="../assets/wechat.svg"
          class="badge-icon"
          alt="WeChat"
        >
        <span class="badge-text">XYHY2024star</span>
      </div>
    </div>
  </div>
</template>

<script>


import { post, get } from "@/api";
import { ElLoading, ElMessage } from "element-plus";
import VueQrcode from 'vue-qrcode';
import swithLanguage from "@/components/swithLanguage.vue";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Pay',
  components: {
    swithLanguage,
    VueQrcode
  },
  data() {
    return {
      TikTokID: "",
      money: "",
      number: 0,
      surplus: 0,
      drawer: false,
      pay_image: "",
      shareRatio: "",
      get_data: {},
      interval: "",
      kami: "",
      platformtext: "",
      options: {
        scale: 6,
        width: 400,
        height: 256,
        color: {
          dark: '#000000ff',
          light: '#ffffffff'
        }
      }
    }
  },
  created() {

    //国际化
    let language = window.localStorage.getItem("language");
    if (language) {
      this.$i18n.locale = language;
    }
    //获取用户数据
    const data = JSON.parse(window.localStorage.getItem("data"));
    if (!data) {
      this.$router.replace("/")
    } else {
      // console.log(data)
      // this.kami = data;
      this.platformtext = data["platform"]
      this.surplus = data["balance"];
      this.TikTokID = data["user"];
      this.judge_kami(data["user"])
    }

    // 从 URL 获取 secret 参数，如果没有则跳转到指定网址
    const urlParams = new URLSearchParams(window.location.search);
    let method = urlParams.get("method");
    let message = urlParams.get("message");
    if (message || method == "alipay.trade.page.pay.return") {
      ElMessage.success(this.$t("pay.paySuccess"));
      // 清除 URL 中的 message 参数
      urlParams.delete("message");
      const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
      window.history.replaceState(null, "", newUrl);
      this.judge_kami(this.tiktok_id)
    }

    // console.log(data)
    // console.log(this.shareRatio)
  },
  methods: {
    customer() {
      window.open("https://www.xyhy.live/contact.html", "_blank");
    },
    alipay() {
      // const loading = ElLoading.service({
      //   lock: true,
      //   text: 'Loading',
      //   background: 'rgba(0, 0, 0, 0.7)',
      // })
      post("/alipay", {
        "kami": null,
        "tiktok_id": this.TikTokID,
        "money": this.money,
        "game_id": 999,
        "platform": this.platformtext
      }).then(res => {
        // console.log(res)

        if (res.code == 400) {
          // loading.close()
          if (res.cnmsg == "tiktok账号不能为空") {
            ElMessage.error(this.$t("notify.tiktokidNULL"));
          } else if (res.cnmsg == "金额不能为空") {
            ElMessage.error(this.$t("notify.moneyNULL"));
          } else {
            ElMessage.error(res.cnmsg);
          }
        } else if (res.code == 200) {
          const order_id = res.data.order_id
          window.location.href = `https://game.zghbqn.com/alipayOrder?order_id=${order_id}`;
          console.log(res)
        }

      })
    },
    paypal() {
      const loading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      // let that = this;
      post("/paypal", {
        "kami": null,
        "tiktok_id": this.TikTokID,
        "money": this.money,
        "game_id": 999,
        "platform": this.platformtext
      }).then(res => {
        // console.log(res)
        if (res.code == 400) {
          loading.close()
          if (res.cnmsg == "tiktok账号不能为空") {
            ElMessage.error(this.$t("notify.tiktokidNULL"));
          } else if (res.cnmsg == "金额不能为空") {
            ElMessage.error(this.$t("notify.moneyNULL"));
          } else {
            ElMessage.error(res.cnmsg);
          }
        } else if (res.code == 200) {
          if (res.data.code === "success") {
            window.location.href = res.data.data.redirect_url
          }
          console.log(res)
        }

      })
    },
    go() {
      const loading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      let that = this;
      post("/pay", {
        "kami": null,
        "tiktok_id": this.TikTokID,
        "money": this.money,
        "game_id": 999,
        "platform": this.platformtext
      }).then(res => {
        // console.log(res)
        loading.close()
        if (res.code == 400) {
          // ElMessage.error(res.cnmsg)
          if (res.cnmsg === "tiktok账号不能为空") {
            ElMessage.error(this.$t("notify.tiktokidNULL"));
          } else if (res.cnmsg === "金额不能为空") {
            ElMessage.error(this.$t("notify.moneyNULL"));
          } else if (res.cnmsg === "卡密不能为空") {
            ElMessage.error(this.$t("notify.cardNULL"));
          } else {
            ElMessage.error(res.cnmsg);
          }
        } else if (res.code == 200 && res.data.code_url) {
          this.drawer = true
          this.pay_image = res.data.code_url

          this.interval = setInterval(function () {
            that.judge(res.data.order_id, this.interval)
          }, 1000)
          // console.log(this.pay_image)
        }
      })
    },
    num() {
      var other = this.shareRatio;
      if (!other) {
        other = 1
      }
      let coin = 0
      if (this.platformtext == "bigo") {
        coin = parseInt(this.money) / 7.2 / 0.1 * 43
      }
      else {
        coin = parseInt(this.money) / (7.2 * other) * 1000
      }
      this.number = parseInt(coin)
    },
    closeDrawer() {
      // console.log(this.interval)
      clearInterval(this.interval)
    },
    judge(order_id, time) {
      let that = this;
      get("/judge_game_statue", { "order_id": order_id }).then(res => {
        // console.log(res)
        if (res.data.game_pay_statue == 1) {
          that.drawer = false;
          ElMessage.success(this.$t("pay.paySuccess"));
          clearInterval(time)
          that.judge_kami(res.data.tiktok_id)
        }
      })
    },
    logout() {
      window.localStorage.removeItem("data");
      this.$router.push("/")
    },
    judge_kami(tiktok_id) { // 变更代码
      post("/judge_Kami", {
        "tiktok_id": tiktok_id,
        "platform": this.platformtext
        // "game_id": this.kami.data.game_id
      }).then(res => {
        if (res.data["errorCode"] == 106) {
          // console.log(res.data)
          ElMessage.error(this.$t("pay.errorSuccess"))
        } else if (res.data["errorCode"] == 0) {
          // console.log(res.data)
          this.surplus = res.data["balance"];
          window.localStorage.setItem("data", JSON.stringify(res.data))
          this.$router.push("/pay")
        }
      }).catch(res => {
        console.log(res)
      })
    },
    gourl() {
      window.location.href = "https://www.xyhy.live"
    }
  }
}
</script>

<style scoped>
.page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 40px;
  position: relative;
  z-index: 10;
}

.logo {
  width: 160px;
  height: auto;
  cursor: pointer;
  transition: opacity var(--transition);
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.4));
}

.logo:hover {
  opacity: 0.85;
}

.language {
  position: static;
}

.contact-badges {
  position: fixed;
  right: 40px;
  bottom: 40px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 100;
}

.badge-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 20px;
  transition: all var(--transition);
}

.badge-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.badge-text {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary);
}

.discord-badge {
  background: rgba(88, 101, 242, 0.15);
  border: 1px solid rgba(88, 101, 242, 0.3);
}

.discord-badge:hover {
  background: rgba(88, 101, 242, 0.22);
  border-color: rgba(88, 101, 242, 0.45);
}

.wechat-badge {
  background: rgba(61, 154, 98, 0.15);
  border: 1px solid rgba(61, 154, 98, 0.3);
}

.wechat-badge:hover {
  background: rgba(61, 154, 98, 0.22);
  border-color: rgba(61, 154, 98, 0.45);
}

@keyframes badgePulse {

  0%,
  100% {
    opacity: 1;
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
  }

  50% {
    opacity: 0.85;
    box-shadow: 0 0 12px 4px rgba(255, 255, 255, 0.15);
  }
}

.badge-item {
  animation: badgePulse 2s ease-in-out infinite;
}

.page-main {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 24px 80px;
  position: relative;
  z-index: 5;
}

.card {
  width: 100%;
  max-width: 500px;
  animation: cardEnter 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes cardEnter {
  from {
    opacity: 0;
    transform: translateY(40px) scale(0.96);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.card-inner {
  position: relative;
  padding: 40px 36px;
  z-index: 1;
}

.card-header {
  text-align: center;
  margin-bottom: 28px;
  padding-bottom: 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
}

.card-title {
  font-size: 1.15rem;
  font-weight: 600;
  margin-bottom: 12px;
  letter-spacing: 0;
  text-transform: none;
}

.platform-badge {
  display: inline-block;
  padding: 4px 14px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.form-section {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* 统一 input-group 外边框，避免 prepend 与输入框双边框 */
.form-section :deep(.el-input-group) {
  display: flex;
  align-items: stretch;
  width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: var(--radius-sm);
  background: rgba(255, 255, 255, 0.04);
  overflow: hidden;
  transition: border-color var(--transition), box-shadow var(--transition), background var(--transition);
}

.form-section :deep(.el-input-group:hover) {
  border-color: rgba(255, 255, 255, 0.16);
  background: rgba(255, 255, 255, 0.05);
}

.form-section :deep(.el-input-group:focus-within) {
  border-color: rgba(129, 140, 248, 0.45);
  box-shadow: 0 0 0 2px rgba(129, 140, 248, 0.12);
}

.form-section :deep(.el-input-group .el-input__wrapper) {
  flex: 1;
  min-height: 44px;
  box-shadow: none !important;
  border-radius: 0 !important;
  background: transparent !important;
}

.form-section :deep(.el-input-group .el-input__wrapper:hover),
.form-section :deep(.el-input-group .el-input__wrapper.is-focus) {
  box-shadow: none !important;
  background: transparent !important;
}

.form-section :deep(.el-input-group__prepend) {
  min-width: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 14px;
  border: none !important;
  border-right: 1px solid rgba(255, 255, 255, 0.08) !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  background: rgba(255, 255, 255, 0.03) !important;
  color: var(--text-secondary) !important;
  font-weight: 500;
  font-size: 13px;
}

.form-section :deep(.el-input.is-disabled .el-input-group) {
  background: rgba(255, 255, 255, 0.02);
  border-color: rgba(255, 255, 255, 0.07);
  opacity: 0.6;
  cursor: not-allowed;
}

.form-section :deep(.el-input.is-disabled .el-input__wrapper) {
  opacity: 1 !important;
  background: transparent !important;
}

.form-section :deep(.el-input.is-disabled .el-input-group__prepend) {
  background: rgba(255, 255, 255, 0.02) !important;
}

.input {
  height: auto;
}

.pay-actions {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 14px;
}

.pay-btn {
  width: 100%;
  height: 46px !important;
  margin-left: 0 !important;
  position: relative;
  overflow: visible;
  font-size: 14px !important;
  font-family: inherit !important;
  font-weight: 500 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-shadow: none !important;
  letter-spacing: 0;
  text-transform: none;
}

.pay-recommended {
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.28),
    0 4px 14px rgba(0, 0, 0, 0.12) !important;
}

.pay-notice {
  box-shadow: inset 0 0 0 1px rgba(255, 200, 120, 0.3) !important;
}

.recommended-badge {
  position: absolute;
  z-index: 1;
  right: 10px;
  top: -8px;
  padding: 2px 8px;
  border: 1px solid rgba(255, 255, 255, 0.58);
  border-radius: 999px;
  background: linear-gradient(135deg, #ffe08a, #ffb84d);
  box-shadow: 0 3px 8px rgba(75, 45, 0, 0.24);
  color: #5d3800;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0.04em;
  pointer-events: none;
}

.notice-badge {
  position: absolute;
  z-index: 1;
  right: 10px;
  top: -8px;
  padding: 2px 8px;
  border: 1px solid rgba(255, 198, 112, 0.72);
  border-radius: 999px;
  background: rgba(28, 35, 54, 0.96);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.24);
  color: #ffd08a;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
  pointer-events: none;
}

.pay-wechat {
  --el-button-bg-color: #3d9a62 !important;
  --el-button-border-color: #3d9a62 !important;
  --el-button-hover-bg-color: #44996a !important;
  --el-button-hover-border-color: #44996a !important;
}

.pay-alipay {
  --el-button-bg-color: #3a7fd4 !important;
  --el-button-border-color: #3a7fd4 !important;
  --el-button-hover-bg-color: #4588d8 !important;
  --el-button-hover-border-color: #4588d8 !important;
}

.pay-paypal {
  --el-button-bg-color: #3a6fa8 !important;
  --el-button-border-color: #3a6fa8 !important;
  --el-button-hover-bg-color: #4578b0 !important;
  --el-button-hover-border-color: #4578b0 !important;
}

.btn-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 5px;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
}

.logout-btn {
  width: 100%;
  height: 42px !important;
  margin-left: 0 !important;
  margin-top: 6px;
  font-family: inherit !important;
  font-size: 14px !important;
  letter-spacing: 0;
}

.qr-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.qr-frame {
  padding: 16px;
  background: #fff;
  border-radius: var(--radius-md);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.3);
}

.qr-frame img {
  display: block;
  border-radius: 4px;
}

.bottom {
  color: var(--text-muted);
  font-weight: 500;
  font-size: 13px;
  text-align: left;
  width: calc(100% - 48px);
  max-width: 760px;
  margin: -16px auto 24px;
  padding: 16px 18px;
  line-height: 1.6;
}

.payment-note {
  border: 1px solid rgba(255, 196, 107, 0.22);
  border-left: 3px solid #f2b55f;
  border-radius: var(--radius-sm);
  background: rgba(255, 184, 77, 0.06);
}

.payment-note-title {
  display: block;
  margin-bottom: 4px;
  color: #ffd08a;
  font-size: 14px;
}

.payment-note p {
  margin: 0;
}
</style>
